import { jsxs, jsx } from "react/jsx-runtime";
import { useTheme } from "@mui/material";
import { getEntityImage } from "../../utils/assetUtils.js";
const formatReviewCount = (count) => {
  if (count >= 1e3) {
    const k = count / 1e3;
    return k % 1 === 0 ? `${k}K` : `${k.toFixed(1)}K`;
  }
  return count.toLocaleString();
};
const StarIcon = () => /* @__PURE__ */ jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "16",
    height: "16",
    viewBox: "0 0 24 24",
    fill: "#FFBD32",
    style: { flexShrink: 0 },
    children: /* @__PURE__ */ jsx("path", { d: "M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z" })
  }
);
const PinnedProductContext = ({
  pageContext,
  product,
  isLoading = false
}) => {
  var _a;
  const theme = useTheme();
  const primaryColor = theme.palette.text.primary;
  if ((pageContext == null ? void 0 : pageContext.pageType) !== "pdp" || !(pageContext == null ? void 0 : pageContext.stacklineSku)) {
    return null;
  }
  const stacklineSku = pageContext.stacklineSku;
  const imageUrl = ((_a = product == null ? void 0 : product.imageUrls) == null ? void 0 : _a[0]) || getEntityImage(stacklineSku, "product");
  const productTitle = product == null ? void 0 : product.title;
  const rating = (product == null ? void 0 : product.reviewsRating) ?? (product == null ? void 0 : product.reviewsAverageRating);
  const reviewCount = product == null ? void 0 : product.reviewsCount;
  if (isLoading) {
    return /* @__PURE__ */ jsxs(
      "div",
      {
        style: {
          display: "flex",
          alignItems: "center",
          gap: "12px",
          padding: "8px 16px",
          backgroundColor: "#ffffff",
          borderBottom: "1px solid #f3f3f3",
          borderRadius: "10px 10px 0 0",
          boxShadow: "8px 8px 14px 0px rgba(0, 0, 0, 0.03)"
        },
        children: [
          /* @__PURE__ */ jsx(
            "div",
            {
              style: {
                width: "48px",
                height: "48px",
                borderRadius: "6px",
                backgroundColor: "#f3f4f6",
                flexShrink: 0
              }
            }
          ),
          /* @__PURE__ */ jsxs(
            "div",
            {
              style: {
                flex: 1,
                display: "flex",
                flexDirection: "column",
                gap: "6px"
              },
              children: [
                /* @__PURE__ */ jsx(
                  "div",
                  {
                    style: {
                      height: "14px",
                      width: "70%",
                      borderRadius: "4px",
                      backgroundColor: "#f3f4f6"
                    }
                  }
                ),
                /* @__PURE__ */ jsx(
                  "div",
                  {
                    style: {
                      height: "12px",
                      width: "40%",
                      borderRadius: "4px",
                      backgroundColor: "#f3f4f6"
                    }
                  }
                )
              ]
            }
          )
        ]
      }
    );
  }
  return /* @__PURE__ */ jsxs(
    "div",
    {
      style: {
        display: "flex",
        alignItems: "center",
        gap: "12px",
        padding: "8px 16px",
        backgroundColor: "#ffffff",
        borderBottom: "1px solid #f3f3f3",
        borderRadius: "10px 10px 0 0",
        boxShadow: "8px 8px 14px 0px rgba(0, 0, 0, 0.03)"
      },
      children: [
        /* @__PURE__ */ jsx(
          "div",
          {
            style: {
              width: "48px",
              height: "48px",
              borderRadius: "6px",
              overflow: "hidden",
              backgroundColor: "#ffffff",
              flexShrink: 0,
              display: "flex",
              alignItems: "center",
              justifyContent: "center"
            },
            children: /* @__PURE__ */ jsx(
              "img",
              {
                src: imageUrl,
                alt: productTitle || "Product",
                style: {
                  width: "100%",
                  height: "100%",
                  objectFit: "contain"
                },
                onError: (e) => {
                  e.target.style.display = "none";
                }
              }
            )
          }
        ),
        /* @__PURE__ */ jsxs(
          "div",
          {
            style: {
              flex: 1,
              minWidth: 0,
              display: "flex",
              flexDirection: "column",
              gap: "2px"
            },
            children: [
              productTitle ? /* @__PURE__ */ jsx(
                "span",
                {
                  style: {
                    fontSize: "14px",
                    fontWeight: 600,
                    color: primaryColor,
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    whiteSpace: "nowrap",
                    lineHeight: "24px"
                  },
                  title: productTitle,
                  children: productTitle
                }
              ) : /* @__PURE__ */ jsx(
                "span",
                {
                  style: {
                    fontSize: "14px",
                    fontWeight: 600,
                    color: primaryColor,
                    lineHeight: "24px"
                  },
                  children: "This product"
                }
              ),
              rating != null && rating > 0 && /* @__PURE__ */ jsxs(
                "div",
                {
                  style: {
                    display: "flex",
                    alignItems: "center",
                    gap: "4px"
                  },
                  children: [
                    /* @__PURE__ */ jsx(StarIcon, {}),
                    /* @__PURE__ */ jsxs(
                      "span",
                      {
                        style: {
                          fontSize: "12px",
                          fontWeight: 500,
                          color: primaryColor,
                          lineHeight: "16px"
                        },
                        children: [
                          rating.toFixed(1),
                          reviewCount != null && reviewCount > 0 && /* @__PURE__ */ jsxs("span", { style: { color: primaryColor }, children: [
                            " ",
                            "(",
                            formatReviewCount(reviewCount),
                            " reviews)"
                          ] })
                        ]
                      }
                    )
                  ]
                }
              )
            ]
          }
        )
      ]
    }
  );
};
export {
  PinnedProductContext
};
//# sourceMappingURL=PinnedProductContext.js.map
